export default __webpack_public_path__ + "static/media/unstoppable.fa40a6f3.webp";